import {MappingTablesCache} from '../../../../mappingTablesCache/mappingTablesCache.service';
import {Injectable} from 'ng-metadata/core';
import {getApiBaseUrl} from '../../../../appConfig/appConfigForward';
import {getBaseUrls} from '../../../../appConfig/appConfigForward';
import {JwtUtilService} from '../../../../security/jwtUtil.service';


@Injectable()
export class LibraryCardMenuService {
    constructor(private mtCache:MappingTablesCache,
				private jwtUtilService :JwtUtilService) {
    }

	public getOpacType() : OPAC_TYPE {
		let ilsBaseUrl = getApiBaseUrl();
		return (ilsBaseUrl) ? OPAC_TYPE.OVP : OPAC_TYPE.OVL;
	}

	public getIlsBaseUrl() {
		//If existed 'My library card' link in 'Templates' MT
		let templateUrl = getBaseUrls()['my_library_card'] || '';

		return templateUrl.replace('__pds_handle__', this.getPdsHandle());
	}

	private getPdsHandle(){
		let jwtClaim = this.jwtUtilService.getDecodedToken();
		return jwtClaim.jti || '';
	}
}


export enum OPAC_TYPE {
	OVL, OVP
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/libraryCard/libraryCardMenu.service.ts